export default __webpack_public_path__ + "static/media/icon-track.b3cef512.svg";